import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Col, Row, Card, Typography, Divider } from 'antd';
import StatusBadge from '../../components/StatusBadges';
import PropTypes from 'prop-types';

const { Title } = Typography;

const ContractInfo = ({ contract }) => {

  const SignerInfo = ({ data }) => (
    <>
      <Row className='mb-4'>
        {data.personaJuridica ?
          <Fragment>
            <Col sm={12}>
              <p><b>EMPRESA</b></p>
              {data.personaJuridica.razon}
            </Col>
            <Col sm={12}>
              <p><b>RUT EMPRESA</b></p>
              {data.personaJuridica.rut && data.personaJuridica.rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
            </Col>
            <Col sm={24} className={'mb-2'}>
              <p><b>GIRO</b></p>
              {data.personaJuridica.giro}
            </Col>
            <Col sm={12}>
              <p><b>REPRESENTANTE LEGAL</b></p>
              {data.nombre} {data.segundoNombre} {data.apellido} {data.segundoApellido}
            </Col>
            <Col sm={12}>
              <p><b>RUT</b></p>
              {data.rut && data.rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
            </Col>
          </Fragment>
          :
          <Fragment>
            <Col sm={12}>
              <p><b>NOMBRE COMPLETO</b></p>
              {data.nombre} {data.segundoNombre} {data.apellido} {data.segundoApellido}
            </Col>
            <Col sm={12}>
              <p><b>RUT</b></p>
              {data.rut && data.rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
            </Col>
          </Fragment>
        }
      </Row>
    </>
  );

  return (
    <Card>
      <Row>
        {contract.estado && <StatusBadge status={contract.estado} />}
      </Row>
      <Row>
        <Title level={3} ellipsis>
          Contrato de arriendo {contract.arrendatario.nombre} {contract.arrendatario.apellido} {contract.arrendatario.segundoApellido}
        </Title>
      </Row>
      <Row>
        <p className="last-update">ID {contract.contractId}</p>
      </Row>
      <Row>
        {contract.id_solicitud && <p className="last-update">ID Notarisa {contract.id_solicitud}</p>}
      </Row>
      <br />
      <Row>
        <Title level={3} ellipsis>
          Arrendador
        </Title>
      </Row>
      <SignerInfo data={{ ...contract.arrendador }} />
      <Divider />
      <Row>
        <Title level={3} ellipsis>
          {contract.arrendatarios && contract.arrendatarios[0] ? 'Arrendatarios' : 'Arrendatario'}
        </Title>
      </Row>
      <SignerInfo data={{ ...contract.arrendatario }} />
      {contract.arrendatarios && contract.arrendatarios.map((lessee, key) => (
        <Fragment key={key}>
          <Divider />
          <SignerInfo data={{ ...lessee }} />
        </Fragment>
      ))}
      {contract.codeudor &&
        <Fragment>
          <Divider />
          <Row>
            <Title level={3} ellipsis>
              {contract.codeudores && contract.codeudores[0] ? 'Codeudores' : 'Codeudor'}
            </Title>
          </Row>
          <SignerInfo data={{ ...contract.codeudor }} />
          {contract.codeudores.map((codebtor, key) => (
            <Fragment key={key}>
              <Divider />
              <SignerInfo data={{ ...codebtor }} />
            </Fragment>
          ))}
        </Fragment>
      }
    </Card>
  );
};

ContractInfo.propTypes = {
  contract: PropTypes.object.isRequired,
  data: PropTypes.object,
};

const data = (state) => ({
  contract: state.contract.contract,
});

export default connect(data, null)(ContractInfo);